// (function () {
//   /* --------------- helpers --------------- */
//   function playActiveVideo(container, swiper) {
//     container.querySelectorAll('video').forEach(v => v.pause());
//     const activeSlide = swiper?.slides?.[swiper.activeIndex];
//     if (!activeSlide) return;

//     const video = activeSlide.querySelector('video');
//     if (!video) return;

//     video.muted = true;
//     video.loop = true;
//     video.controls = false;
//     video.playsInline = true;
//     video.currentTime = 0;
//     video.play().catch(() => {});

//     container.querySelectorAll('.swiper-slide').forEach(s =>
//       s.classList.remove('playing')
//     );
//     activeSlide.classList.add('playing');
//   }

//   /* --------------- dots builder --------------- */
//   function buildDots(root, swiper) {
//     let wrap = root.querySelector('.video-slider--dots');
//     if (!wrap) {
//       wrap = document.createElement('div');
//       wrap.className = 'video-slider--dots';
//       root.appendChild(wrap);
//     }

//     wrap.innerHTML = '';

//     const realSlides = swiper.slides.filter(
//       sl => !sl.classList.contains('swiper-slide-duplicate')
//     );

//     // Get current slidesPerView
//     const currentSlidesPerView = swiper.params.slidesPerView;
    
//     // Only show dots if there are more slides than can fit in view
//     if (realSlides.length <= currentSlidesPerView) {
//       wrap.style.display = 'none';
//       return;
//     }
    
//     wrap.style.display = 'flex';

//     // Calculate number of pages/positions based on slidesPerView
//     // For 4 slides with 3 per view = 2 pages (positions 0 and 1)
//     const numPages = realSlides.length - currentSlidesPerView + 1;

//     // Create dots for each page, not each slide
//     for (let i = 0; i < numPages; i++) {
//       const dot = document.createElement('button');
//       dot.className = 'video-slider--dot';
//       dot.addEventListener('click', () => swiper.slideTo(i, 300));
//       wrap.appendChild(dot);
//     }

//     const update = () => {
//       const active = swiper.activeIndex;
//       wrap.querySelectorAll('.video-slider--dot').forEach((d, i) =>
//         d.classList.toggle('active', i === active)
//       );
//     };

//     swiper.on('slideChange', update);
//     update();
//   }

//   /* --------------- slider init --------------- */
//   function initSliders() {
//     document.querySelectorAll('.video-slider--root').forEach(root => {
//       const id = root.dataset.sectionId;
//       const cfg = window.videoSlider?.sections?.[id];
//       if (!cfg) return;

//       const swiperEl = root.querySelector('.mySwiper');
//       if (!swiperEl) return;

//       /* ---------- POPUP LOGIC (ALWAYS ACTIVE) ---------- */
//       const popup = document.getElementById('videoPopup-theme');
//       const popupV = document.getElementById('popupVideo-theme');
//       const prevBtn = popup?.querySelector('.video-popup__nav--prev');
//       const nextBtn = popup?.querySelector('.video-popup__nav--next');

//       if (popup && popupV) {
//         // Collect all video sources from slides
//         let videoSources = [];
//         let currentVideoIndex = 0;

//         const collectVideoSources = () => {
//           videoSources = Array.from(
//             root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) video')
//           ).map(v => ({
//             src: v.currentSrc || v.src || v.querySelector('source')?.src,
//             element: v
//           })).filter(item => item.src);
//         };

//         const updateNavigationButtons = () => {
//           if (prevBtn) {
//             prevBtn.disabled = currentVideoIndex === 0;
//           }
//           if (nextBtn) {
//             nextBtn.disabled = currentVideoIndex === videoSources.length - 1;
//           }
//         };

//         const showVideoInPopup = (index) => {
//           if (index < 0 || index >= videoSources.length) return;
          
//           currentVideoIndex = index;
//           popupV.src = videoSources[index].src;
//           popupV.muted = false;
//           popupV.controls = true;
//           popupV.load();
//           updateNavigationButtons();
          
//           setTimeout(() => popupV.play().catch(() => {}), 100);
//         };

//         // Open popup when clicking on a slide
//         root.addEventListener('click', e => {
//           const slide = e.target.closest('.swiper-slide');
//           if (!slide) return;

//           const v = slide.querySelector('video');
//           if (!v) return;

//           collectVideoSources();
          
//           // Find the index of clicked video
//           const clickedSrc = v.currentSrc || v.src || slide.querySelector('source')?.src;
//           currentVideoIndex = videoSources.findIndex(item => item.src === clickedSrc);
          
//           if (currentVideoIndex === -1) currentVideoIndex = 0;

//           popup.classList.add('active');
//           showVideoInPopup(currentVideoIndex);
//         });

//         // Previous button
//         if (prevBtn) {
//           prevBtn.addEventListener('click', (e) => {
//             e.stopPropagation();
//             if (currentVideoIndex > 0) {
//               showVideoInPopup(currentVideoIndex - 1);
//             }
//           });
//         }

//         // Next button
//         if (nextBtn) {
//           nextBtn.addEventListener('click', (e) => {
//             e.stopPropagation();
//             if (currentVideoIndex < videoSources.length - 1) {
//               showVideoInPopup(currentVideoIndex + 1);
//             }
//           });
//         }

//         const closePopup = () => {
//           popupV.pause();
//           popupV.currentTime = 0;
//           popup.classList.remove('active');
//         };

//         popup.addEventListener('click', e => {
//           if (
//             e.target === popup ||
//             e.target.classList.contains('video-popup__close')
//           ) {
//             closePopup();
//           }
//         });

//         // Keyboard navigation
//         document.addEventListener('keydown', e => {
//           if (!popup.classList.contains('active')) return;
          
//           if (e.key === 'Escape') {
//             closePopup();
//           } else if (e.key === 'ArrowLeft' && currentVideoIndex > 0) {
//             showVideoInPopup(currentVideoIndex - 1);
//           } else if (e.key === 'ArrowRight' && currentVideoIndex < videoSources.length - 1) {
//             showVideoInPopup(currentVideoIndex + 1);
//           }
//         });
//       }

//       /* ---------- SLIDE COUNT CHECK ---------- */
//       const totalSlides = swiperEl.querySelectorAll(
//         '.swiper-slide:not(.swiper-slide-duplicate)'
//       ).length;

//       // Determine max slidesPerView based on screen size
//       const getMaxSlidesPerView = () => {
//         return window.innerWidth >= 1280 ? cfg.slidesPerViewDesktop : cfg.slidesPerViewMobile;
//       };

//       /* ❌ NO SLIDER IF ALL SLIDES FIT IN VIEW */
//       if (totalSlides <= getMaxSlidesPerView()) {
//         swiperEl.classList.add('whout_slider_video');

//         const firstVideo = swiperEl.querySelector('.swiper-slide video');
//         if (firstVideo) {
//           firstVideo.muted = true;
//           firstVideo.loop = true;
//           firstVideo.controls = false;
//           firstVideo.playsInline = true;
//           firstVideo.play().catch(() => {});
//         }
//         return;
//       }

//       /* ---------- INIT CAROUSEL ---------- */
//       const carousel = new window.FoxTheme.Carousel(swiperEl, {
//         slidesPerView: cfg.slidesPerViewMobile,
//         spaceBetween: 10,
//         breakpoints: {
//           1280: {
//             slidesPerView: cfg.slidesPerViewDesktop,
//             spaceBetween: 15
//           }
//         },
//         loop: false,
//         watchSlidesProgress: true,
//         slideToClickedSlide: true
//       });

//       carousel.init();
//       const swiper = carousel.slider;

//       swiper.on('slideChange', () => playActiveVideo(root, swiper));

//       root.querySelectorAll('video').forEach(v => {
//         v.addEventListener('ended', () => swiper.slideNext());
//       });

//       swiper.on('init', () =>
//         requestAnimationFrame(() => buildDots(root, swiper))
//       );

//       // Rebuild dots on breakpoint change
//       swiper.on('breakpoint', () => {
//         requestAnimationFrame(() => buildDots(root, swiper));
//       });

//       if (swiper.initialized) {
//         requestAnimationFrame(() => buildDots(root, swiper));
//       }

//       const kick = () => playActiveVideo(root, swiper);
//       if (swiper.initialized) kick();
//       else swiper.on('init', kick);
//     });
//   }

//   /* --------------- run --------------- */
//   initSliders();

//   if (window.Shopify?.designMode) {
//     document.addEventListener('shopify:section:load', initSliders);
//   }
// })();


(function () {

    /* --------------- helpers --------------- */
    function playActiveVideo(container, swiper) {
      container.querySelectorAll('video').forEach(v => v.pause());
  
      const activeSlide = swiper?.slides?.[swiper.activeIndex];
      if (!activeSlide) return;
  
      const video = activeSlide.querySelector('video');
      if (!video) return;
  
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.playsInline = true;
      video.currentTime = 0;
      video.play().catch(() => {});
  
      container.querySelectorAll('.swiper-slide')
        .forEach(s => s.classList.remove('playing'));
  
      activeSlide.classList.add('playing');
    }
  
    /* --------------- dots builder --------------- */
    function buildDots(root, swiper) {
  
      let wrap = root.querySelector('.video-slider--dots');
  
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'video-slider--dots';
        root.appendChild(wrap);
      }
  
      wrap.innerHTML = '';
  
      const realSlides = swiper.slides.filter(
        sl => !sl.classList.contains('swiper-slide-duplicate')
      );
  
      const currentSlidesPerView = swiper.params.slidesPerView;
  
      if (realSlides.length <= currentSlidesPerView) {
        wrap.style.display = 'none';
        return;
      }
  
      wrap.style.display = 'flex';
  
      const numPages = realSlides.length - currentSlidesPerView + 1;
  
      for (let i = 0; i < numPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'video-slider--dot';
        dot.addEventListener('click', () => swiper.slideTo(i, 300));
        wrap.appendChild(dot);
      }
  
      const update = () => {
        const active = swiper.activeIndex;
        wrap.querySelectorAll('.video-slider--dot')
          .forEach((d, i) =>
            d.classList.toggle('active', i === active)
          );
      };
  
      swiper.on('slideChange', update);
      update();
    }
  
    /* --------------- slider init --------------- */
    function initSliders() {
  
      document.querySelectorAll('.video-slider--root')
        .forEach(root => {
  
          const id = root.dataset.sectionId;
          const cfg = window.videoSlider?.sections?.[id];
          if (!cfg) return;
  
          const swiperEl = root.querySelector('.mySwiper');
          if (!swiperEl) return;
  
          /* ---------- POPUP LOGIC ---------- */
          const popup = document.getElementById('videoPopup-theme');
          const popupV = document.getElementById('popupVideo-theme');
          const prevBtn = popup?.querySelector('.video-popup__nav--prev');
          const nextBtn = popup?.querySelector('.video-popup__nav--next');
  
          if (popup && popupV) {
  
            let videoSources = [];
            let currentVideoIndex = 0;
  
            const collectVideoSources = () => {
              videoSources = Array.from(
                root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) video')
              ).map(v => ({
                src: v.currentSrc || v.src || v.querySelector('source')?.src
              })).filter(item => item.src);
            };
  
            const updateNavigationButtons = () => {
              if (prevBtn) prevBtn.disabled = currentVideoIndex === 0;
              if (nextBtn) nextBtn.disabled = currentVideoIndex === videoSources.length - 1;
            };
  
            const showVideoInPopup = (index) => {
              if (index < 0 || index >= videoSources.length) return;
  
              currentVideoIndex = index;
  
              popupV.src = videoSources[index].src;
              popupV.muted = false;
              popupV.controls = true;
              popupV.load();
  
              updateNavigationButtons();
  
              setTimeout(() => popupV.play().catch(() => {}), 100);
            };
  
            root.addEventListener('click', e => {
  
              const slide = e.target.closest('.swiper-slide');
              if (!slide) return;
  
              const v = slide.querySelector('video');
              if (!v) return;
  
              collectVideoSources();
  
              const clickedSrc =
                v.currentSrc || v.src || slide.querySelector('source')?.src;
  
              currentVideoIndex =
                videoSources.findIndex(item => item.src === clickedSrc);
  
              if (currentVideoIndex === -1) currentVideoIndex = 0;
  
              popup.classList.add('active');
              showVideoInPopup(currentVideoIndex);
            });
  
            if (prevBtn) {
              prevBtn.addEventListener('click', e => {
                e.stopPropagation();
                if (currentVideoIndex > 0) {
                  showVideoInPopup(currentVideoIndex - 1);
                }
              });
            }
  
            if (nextBtn) {
              nextBtn.addEventListener('click', e => {
                e.stopPropagation();
                if (currentVideoIndex < videoSources.length - 1) {
                  showVideoInPopup(currentVideoIndex + 1);
                }
              });
            }
  
          const closePopup = () => {
              popupV.pause();
              popupV.currentTime = 0;
              popup.classList.remove('active');
            };
  
            // Close when clicking backdrop
            popup.addEventListener('click', e => {
              if (e.target === popup) {
                closePopup();
              }
            });

            // Explicit listener on close button (X)
            const closeBtn = popup.querySelector('.video-popup__close');
            if (closeBtn) {
              closeBtn.addEventListener('click', e => {
                e.stopPropagation();
                closePopup();
              });
            }
  
            document.addEventListener('keydown', e => {
              if (!popup.classList.contains('active')) return;
  
              if (e.key === 'Escape') closePopup();
              else if (e.key === 'ArrowLeft' && currentVideoIndex > 0)
                showVideoInPopup(currentVideoIndex - 1);
              else if (e.key === 'ArrowRight' &&
                       currentVideoIndex < videoSources.length - 1)
                showVideoInPopup(currentVideoIndex + 1);
            });
          }
  
          /* ---------- INIT CAROUSEL (THEME SWIPER) ---------- */
          // Use theme settings from window.videoSlider.sections (set in snippet)
          const swiperOptions = {
            // Mobile: use block setting slides_per_row_mobile
            slidesPerView: cfg.slidesPerViewMobile,
            // Always move one slide at a time
            slidesPerGroup: 1,
            spaceBetween: 10,
            breakpoints: {
              // Desktop breakpoint: use block setting slides_per_row
              1280: {
                slidesPerView: cfg.slidesPerViewDesktop,
                slidesPerGroup: 1,
                spaceBetween: 15
              }
            },
            loop: false,
            watchSlidesProgress: true,
            slideToClickedSlide: true
          };

          let swiper;
          if (typeof window.FoxTheme !== 'undefined' && typeof window.FoxTheme.Carousel === 'function') {
            const carousel = new window.FoxTheme.Carousel(swiperEl, swiperOptions);
            carousel.init();
            swiper = carousel.slider;
          } else if (typeof Swiper !== 'undefined') {
            swiper = new Swiper(swiperEl, swiperOptions);
          } else {
            return;
          }
  
          /* ---------- HEADER NAVIGATION ---------- */
          const prevHeaderBtn = root.querySelector('.video-slider-prev');
          const nextHeaderBtn = root.querySelector('.video-slider-next');
  
          if (prevHeaderBtn) {
            prevHeaderBtn.addEventListener('click', () => swiper.slidePrev());
          }
  
          if (nextHeaderBtn) {
            nextHeaderBtn.addEventListener('click', () => swiper.slideNext());
          }
  
          const updateNavState = () => {
            if (prevHeaderBtn)
              prevHeaderBtn.disabled = swiper.isBeginning;
  
            if (nextHeaderBtn)
              nextHeaderBtn.disabled = swiper.isEnd;
          };
  
          swiper.on('slideChange', updateNavState);
          swiper.on('init', updateNavState);
          updateNavState();
  
          /* ---------- VIDEO AUTO PLAY ---------- */
          swiper.on('slideChange', () => playActiveVideo(root, swiper));
  
          root.querySelectorAll('video').forEach(v => {
            v.addEventListener('ended', () => swiper.slideNext());
          });
  
          swiper.on('init', () =>
            requestAnimationFrame(() => buildDots(root, swiper))
          );
  
          swiper.on('breakpoint', () =>
            requestAnimationFrame(() => buildDots(root, swiper))
          );
  
          if (swiper.initialized)
            requestAnimationFrame(() => buildDots(root, swiper));
  
          const kick = () => playActiveVideo(root, swiper);
  
          if (swiper.initialized) kick();
          else swiper.on('init', kick);
        });
    }
  
    /* --------------- run --------------- */
    initSliders();
  
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initSliders);
    }
  
  })();